export function isBackgroundThreadMetadata(metadata: unknown): boolean {
  if (!metadata || typeof metadata !== 'object' || Array.isArray(metadata)) return false;

  const record = metadata as { source?: unknown; is_background?: unknown };
  return record.is_background === true || record.source === 'background_agent';
}
